<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button mat-raised-button [matMenuTriggerFor]="menu" class="m-r-5 pg-profile-btn" *ngIf="layaoutExit"
  matTooltip="Mi cuenta" matTooltipPosition="below" [matTooltipShowDelay]="400" matTooltipClass="pg-tooltip">
  <img src="../../../../assets/images/users/16196015_10154888128487744_6901111466535510271_n.png" alt="user"
    class="profile-pic">
  <span class="pg-profile-name">{{nombre}}</span>
  <mat-icon class="pg-profile-chevron">expand_more</mat-icon>
</button>

<mat-menu #menu="matMenu" class="mymegamenu">
  <!-- <button mat-menu-item [routerLink]="['seguridad/perfil']">
    <mat-icon style="color: #f8f8f8">account_circle</mat-icon> Perfil
  </button> -->
  <!-- <button mat-menu-item [routerLink]="['seguridad/personalizacion']">
    <mat-icon style="color: #f8f8f8">format_paint</mat-icon> Personalizar
  </button> -->
  <button mat-menu-item (click)="salir()" class="exit">
    <mat-icon>exit_to_app</mat-icon> Salir
  </button>
</mat-menu>
